import { createFileRoute } from '@tanstack/react-router';
import { JourneysFacebookFormsHandoff } from '@/pages/workspaces/integrations/forms/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/facebook_lead_ads_/$formId',
)({
  component: JourneysFacebookFormHandoffRoute,
});

function JourneysFacebookFormHandoffRoute() {
  const { workspaceId, formId } = Route.useParams();
  return <JourneysFacebookFormsHandoff workspaceId={String(workspaceId)} formId={formId} />;
}
